export enum ProgramCategory {
  Special = 'special',
  Regular = 'regular',
  Other = 'general',
  DoubleLesson = 'doubleLesson',
}
